import './vendor';
import lazyLoading from './modules/lazyLoading';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')
require('/src/js/vendor/mmenu/jquery.mmenu.all.js')

import NativejsSelect from 'nativejs-select';

import Swiper, { Pagination, Autoplay, Navigation, EffectFade, Controller, Mousewheel} from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade,  Pagination, Controller, Mousewheel ]);

lazyLoading.init();

$("#menu").mmenu({
	navbar: {
		title: "Каталог товаров"
	}
});

new NativejsSelect({
	selector: '.customSelect',
 });

$('.gallery').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	asNavFor: '.gallery-thumb'
 });

$('.gallery-thumb').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	asNavFor: '.gallery',
	focusOnSelect: true,
	vertical: true,
	prevArrow: $("#gallery-up"),
	nextArrow: $("#gallery-down"),
	responsive: [
		{
		  breakpoint: 1200,
		  settings: {
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    infinite: true,
		    dots: true
		  }
		},
		{
		  breakpoint: 1024,
		  settings: {
		    slidesToShow: 3,
		    slidesToScroll: 3
		  }
		},
		{
		  breakpoint: 768,
		  settings: {
		    slidesToShow: 1,
		    slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 576,
		  settings: {
		    slidesToShow: 1,
		    slidesToScroll: 1
		  }
		},
		{
		  breakpoint: 0,
		  settings: {
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    vertical: false,
		  }
		}
	      ]
});

$('.subcat-tags ').slick({
	slidesToShow: 5,
	slidesToScroll: 1,
	variableWidth: true,
	focusOnSelect: true,
	prevArrow: '<button type="button" class="btn-slider prev"><svg><use xlink:href="/images/sprites.svg#left"></use></svg></button>',
	nextArrow: '<button type="button" class="btn-slider next"><svg><use xlink:href="/images/sprites.svg#next"></use></svg></button>',
});

$('.subcats-destroy').click(function(){
	$($(this).parents('.category-page__subcats').find('.subcat-tags')).slick('unslick');
	$($(this).parents('.category-page__subcats').find('.subcat-tags')).addClass('unslick');
	$(this).toggleClass('is-hidden');
	$(this).siblings('.subcats-init').toggleClass('is-hidden');
});

$('.subcats-init').click(function(){
	$($(this).parents('.category-page__subcats').find('.subcat-tags')).slick('init');
	$($(this).parents('.category-page__subcats').find('.subcat-tags')).removeClass('unslick');
	$(this).toggleClass('is-hidden');
	$(this).siblings('.subcats-destroy').toggleClass('is-hidden');
});


$('.prodtabs__titlemobile ').click(function(){
	$($(this).parents('.prodtabs__content').find('.prodtabs__wrapper')).slideToggle();
	$(this).toggleClass('is-active');
});


$('#open-filter').click(function(){
	$(".filters").addClass('is-open');
	$(".overlay--filters").addClass('is-active');
	$("body").addClass('is-openfilter');
});


$('.overlay--filters, #close-filter-btn ').click(function(){
	$(".filters").removeClass('is-open');
	$(".overlay--filters").removeClass('is-active');
	$("body").removeClass('is-openfilter');
});


$('#opensearch').click(function(){
	$(this).toggleClass('is-active');
	$(".searchform").toggleClass('is-active')

	$('#openmenu').removeClass('is-active');
	$(".header__menu").removeClass('is-active')
});

$('#openmenu').click(function(){
	$(this).toggleClass('is-active');
	$(".header__menu").toggleClass('is-active')

	$('#opensearch').removeClass('is-active');
	$(".searchform").removeClass('is-active')
});





$('.number__minus').click(function () {
	var $input = $(this).parent().find('input');
	var count = parseInt($input.val()) - 1;
	count = count < 1 ? 1 : count;
	$input.val(count);
	$input.change();
	return false;
});
$('.number__plus').click(function () {
	var $input = $(this).parent().find('input');
	$input.val(parseInt($input.val()) + 1);
	$input.change();
	return false;
});

const swiper = new Swiper('.heroslider', { 
        loop: true,
	slidesPerView: 1,
	spaceBetween: 0,
	paginationClickable: true,
	autoHeight: true,
	speed: 1000,
	effect: 'fade',
	fadeEffect: {
		crossFade: true
	},
	autoplay: {
		delay: 3000,
	},
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true
	},
	
});

const sliderProducts = new Swiper('.slider-products', { 
	loop: true,
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: -1,
	speed: 1000,
	navigation: {
		prevEl: '#product-prev',
		nextEl: '#product-next',
	},
	autoplay: {
		delay: 3000,
	},
        breakpoints: {
            1920: {
                slidesPerView: 3,
            },
            1028: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 2,
            }
        }
});



const news = new Swiper('.slider-news', { 
	loop: true,
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: -1,
	speed: 1000,
	navigation: {
		prevEl: '#news-prev',
		nextEl: '#news-next',
	},
	autoplay: {
		delay: 3000,
	},
        breakpoints: {
            1920: {
                slidesPerView: 3,
            },
            1028: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});


const video = new Swiper('.slider-videos', { 
	loop: true,
        slidesPerView: 3,
        paginationClickable: true,
        spaceBetween: 20,
	speed: 1000,
	navigation: {
		prevEl: '#video-prev',
		nextEl: '#video-next',
	},
	autoplay: {
		delay: 3000,
	},
        breakpoints: {
            1920: {
                slidesPerView: 3,
            },
            1028: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
	    320: {
                slidesPerView: 1,
            }
        }
});


const marquee = new Swiper('.brands', { 
	loop: true,
        slidesPerView: 6,
        spaceBetween: 0,
	speed: 5000,
	grabCursor: true,
	autoplay: {
		delay: 0,
	},
        breakpoints: {
            1920: {
                slidesPerView: 6,
            },
            1024: {
                slidesPerView: 6,
            },
            576: {
                slidesPerView: 3,
            },
	    320: {
                slidesPerView: 2,
            }
        }
});



$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
	disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false
});


$("#btn-cat").click(function() {
	$(this).toggleClass("is-active");
	$(".submenu").toggleClass("is-open");
	$("#btn-cat span").text(function(i, text){
		return text === "Закрыть каталог" ? "Каталог продукции" : "Закрыть каталог";
	})
});





/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#name',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});



$(".prodtabs .prodtabs__content ").not(":first").hide();
$(".prodtabs .prodtabs__tab").click(function() {
	$(".prodtabs .prodtabs__tab").removeClass("is-active").eq($(this).index()).addClass("is-active");
	$(".prodtabs .prodtabs__content ").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("is-active");



$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});


/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});
